export enum ManageArticleModeEnum {
    Unset = 0,
    Create = 1,
    Update = 2
}
